import {PROCESSING_ACTIONS} from "./types";

const _add = (id, __extend=undefined) => ({type: PROCESSING_ACTIONS.ADD, id, __extend});
const _remove = id => ({type: PROCESSING_ACTIONS.REMOVE, id});
// const _clear = () => ({type: PROCESSING_ACTIONS.CLEAR});

const _extend = (id, extend) => extend ? `${id}-${extend}` : id;

export const addProcessing = (id, extend='') => _add(_extend(id, extend));
export const removeProcessing = (id, extend='') => _remove(_extend(id, extend));

export const isProcessing = (state, id, extend='') => !!state.processing[_extend(id, extend)] ;

export const isProcessDispatch = (id, extend = '') =>
	(dispatch, getState) => {
		const check = _extend(id, extend);
		return !!getState().processing[check];
	};


// WEBPACK FOOTER //
// ./src/actions/processingActions.js